"use strict";

/** Même découpage pour l'impression HTML et le téléchargement mobile sur canvas. */
function getInvoicePageLayout(element, { pageHeightPixels, pageMarginPixels, canvasScale = 1 }) {
  const sourceRect = element.getBoundingClientRect();
  const measure = selector => {
    const rect = element.querySelector(selector)?.getBoundingClientRect();
    return rect ? {
      top: Math.floor((rect.top - sourceRect.top) * canvasScale),
      height: Math.ceil(rect.height * canvasScale),
      bottom: Math.ceil((rect.bottom - sourceRect.top) * canvasScale),
    } : { top: 0, height: 0, bottom: 0 };
  };
  const footer = measure(".invoice-footer-body");
  const declaration = measure(".invoice-amount-words");
  const footerPageTop = pageHeightPixels - pageMarginPixels - footer.height;
  const contentPageBottom = footerPageTop - declaration.height;
  if (contentPageBottom <= pageMarginPixels) throw new Error("Les informations de l'établissement dépassent la hauteur d'une page A4");
  const contentBottom = measure(".invoice-content").bottom;
  const tableHeader = measure(".products-table thead tr");
  const productsBottom = measure(".products-table tbody tr:last-child").bottom;
  const blocks = Array.from(element.querySelectorAll(
    ".header, .recipient, .products-table tr, .payment-status, .additional-section"
  )).map(block => {
    const rect = block.getBoundingClientRect();
    return { top: (rect.top - sourceRect.top) * canvasScale, bottom: (rect.bottom - sourceRect.top) * canvasScale };
  });
  const slices = [];
  for (let top = 0; top < contentBottom;) {
    const repeatHeader = top > 0 && top >= tableHeader.top + tableHeader.height && top < productsBottom;
    const targetTop = top > 0 ? pageMarginPixels + (repeatHeader ? tableHeader.height : 0) : 0;
    const maxSliceHeight = Math.max(1, contentPageBottom - targetTop);
    let bottom = Math.min(contentBottom, top + maxSliceHeight);
    const crossingBlock = blocks.find(block => block.top > top && block.top < bottom && block.bottom > bottom);
    if (crossingBlock) bottom = Math.ceil(crossingBlock.top);
    if (bottom <= top) bottom = Math.min(contentBottom, top + maxSliceHeight);
    slices.push({ top, height: bottom - top, targetTop, repeatHeader });
    top = bottom;
  }
  return { slices, footer, declaration, footerPageTop, tableHeader };
}

/** Fonction autonome intégrée au HTML : aucun serveur ni script externe requis. */
function installInvoicePrintPagination(layoutFor) {
  const cleanup = () => {
    document.querySelector(".invoice-print-pages")?.remove();
    document.body.classList.remove("invoice-is-paginated");
  };
  window.addEventListener("beforeprint", () => {
    cleanup();
    const source = document.querySelector(".invoice-box");
    if (!source) return;
    // La largeur et les métriques sont celles du média print, après chargement
    // des polices. Le QR et les coordonnées restent répétés ; seule la mention
    // est ajoutée au dernier feuillet.
    const pageHeight = source.getBoundingClientRect().width * 277 / 190;
    const layout = layoutFor(source, { pageHeightPixels: pageHeight, pageMarginPixels: 0 });
    const sourceTop = source.getBoundingClientRect().top;
    const rowBottoms = Array.from(source.querySelectorAll(".products-table tbody tr"))
      .map(row => row.getBoundingClientRect().bottom - sourceTop);
    const pages = document.createElement("div");
    pages.className = "invoice-print-pages";
    layout.slices.forEach((slice, index) => {
      const page = document.createElement("section");
      page.className = "invoice-print-page";
      const content = document.createElement("div");
      content.className = "invoice-print-content";
      content.style.top = slice.targetTop + "px";
      // Sur le dernier feuillet, conserver aussi les bordures et les marges
      // du dernier bloc, que le moteur d'impression peut mesurer différemment.
      const visibleHeight = index === layout.slices.length - 1
        ? layout.footerPageTop - layout.declaration.height - slice.targetTop : slice.height;
      content.style.height = visibleHeight + "px";
      const main = source.querySelector(".invoice-content").cloneNode(true);
      main.style.transform = "translateY(-" + slice.top + "px)";
      // Chromium peut peindre le bas d'une lettre d'une ligne précédente au
      // bord du clip. La masquer conserve sa hauteur et l'alignement des lignes.
      main.querySelectorAll(".products-table tbody tr").forEach((row, rowIndex) => {
        if (rowBottoms[rowIndex] <= slice.top) row.style.visibility = "hidden";
      });
      content.appendChild(main);
      page.appendChild(content);
      if (slice.repeatHeader) {
        const header = document.createElement("table");
        header.className = "products-table invoice-print-table-header";
        header.appendChild(source.querySelector(".products-table thead").cloneNode(true));
        page.appendChild(header);
      }
      const footer = source.querySelector(".invoice-footer-body").cloneNode(true);
      footer.classList.add("invoice-print-footer");
      page.appendChild(footer);
      if (index === layout.slices.length - 1) {
        const declaration = source.querySelector(".invoice-amount-words");
        if (declaration) {
          const lastDeclaration = declaration.cloneNode(true);
          lastDeclaration.classList.add("invoice-print-declaration");
          lastDeclaration.style.bottom = layout.footer.height + "px";
          page.appendChild(lastDeclaration);
        }
      }
      pages.appendChild(page);
    });
    document.body.appendChild(pages);
    document.body.classList.add("invoice-is-paginated");
  });
  window.addEventListener("afterprint", cleanup);
}

module.exports = { getInvoicePageLayout, installInvoicePrintPagination };
